<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <div>
        <v-dialog persistent v-model="showClientModal" scrollable :max-width="1200" @close="close">
            <v-card>
                <v-card-title>
                    <span class="headline">{{ formTitle }}</span>
                </v-card-title>
                <v-card-text  class="mx-0, px-0">

                    <!--TABS-->
                    <v-tabs
                        v-model="active_tab"
                        color="blue-grey darken-2 white--text"
                        dark
                        slider-color="blue-grey darken-1"
                        grow
                    >
                    <!--Tab General-->
                    <v-tab :key="'tab_general'" ripple>Geral</v-tab>
                    <v-tab-item :key="'tab_general'" >
                        <v-container grid-list-md>
                            <v-layout wrap>
                                <v-flex xs12 sm6 md4 px-2>
                                    <v-text-field v-model="formClient.name"
                                        :counter="$v.formClient.name.$params.maxLength.max"
                                        :error-messages="nameErrors"
                                        @blur="$v.formClient.name.$touch()"
                                        :disabled="clientShow"
                                        label="Nome*"></v-text-field>
                                </v-flex>
                                <v-flex xs12 sm6 md4 px-2>
                                    <v-text-field type="number" v-model="formClient.nif"
                                        item-text="name"
                                        item-value="id"
                                        :error-messages="nifErrors"
                                        @blur="$v.formClient.nif.$touch()"
                                        :disabled="clientShow"
                                        label="Nif*"></v-text-field>
                                </v-flex>
                                <v-flex xs12 sm6 md4 px-2>
                                    <v-select v-model="formClient.types_company_type_id"
                                        item-text="name"
                                        item-value="id"
                                        :error-messages="companyTypeErrors"
                                        @blur="$v.formClient.types_company_type_id.$touch()"
                                        :disabled="clientShow"
                                        :items="companyTypes" label="Tipo de entidade*"></v-select>
                                </v-flex>
                                <v-flex xs12 sm6 md4 px-2>
                                    <v-select v-model="formClient.cities_id"
                                        item-text="name"
                                        item-value="id"
                                        :error-messages="cityErrors"
                                        @blur="$v.formClient.cities_id.$touch()"
                                        :disabled="clientShow"
                                        :items="cities" label="Cidade*"></v-select>
                                </v-flex>
                                <v-flex xs12 sm6 md4 px-2>
                                    <v-select v-model="formClient.active_state"
                                        :color="formClient.active_state ? 'green' : 'red'"
                                        item-text="name"
                                        item-value="id"
                                        :error-messages="activeStateErrors"
                                        @blur="$v.formClient.active_state.$touch()"
                                        :disabled="clientShow"
                                        :items="active_states" label="Estado*"></v-select>
                                </v-flex>
                                <v-flex xs12 sm6 md4 px-2>
                                    <v-text-field v-model="formClient.agreed_discount"
                                        type="number"
                                        :error-messages="agreedDiscountErrors"
                                        @blur="$v.formClient.agreed_discount.$touch()"
                                        :disabled="clientShow"
                                        suffix="%"
                                        label="Desconto(%)"></v-text-field>
                                </v-flex>
                                <v-flex xs12 sm6 md4 px-2>
                                    <v-text-field v-model="formClient.address"
                                        :counter="$v.formClient.address.$params.maxLength.max"
                                        :error-messages="addressErrors"
                                        @blur="$v.formClient.address.$touch()"
                                        :disabled="clientShow"
                                        label="Endereço"></v-text-field>
                                </v-flex>
                                <v-flex xs12 sm4 px-2>
                                    <v-combobox
                                        v-model.number="formClient.category"
                                        :items="categories"
                                        item-text="name"
                                        item-value="id"
                                        :disabled="clientShow"
                                        :small-chips="!!formClient.category && !!formClient.category.id"
                                        label="Categoria"
                                    ></v-combobox>
                                </v-flex>
                                <v-flex xs12 sm4 px-2>
                                    <v-combobox
                                        v-model="formClient.subcategory"
                                        :items="subcategories"
                                        item-text="name"
                                        item-value="id"
                                        :disabled="clientShow"
                                        :small-chips="!!formClient.subcategory && !!formClient.subcategory.id"
                                        label="Subcategoria"
                                    ></v-combobox>
                                </v-flex>
                                <v-flex xs12 sm6 md4 px-2>
                                    <v-text-field type="number"
                                        v-model="formClient.postal_code"
                                        :counter="$v.formClient.description.$params.maxLength.max"
                                        item-text="name"
                                        item-value="id"
                                        :error-messages="postalCodeErrors"
                                        @blur="$v.formClient.postal_code.$touch()"
                                        :disabled="clientShow"
                                        label="Código postal"></v-text-field>
                                </v-flex>
                                <v-flex xs12 sm6 md4 px-2>
                                    <v-text-field v-model="formClient.website"
                                        :counter="$v.formClient.website.$params.maxLength.max"
                                        :error-messages="websiteErrors"
                                        @blur="$v.formClient.website.$touch()"
                                        :disabled="clientShow"
                                        label="Website"></v-text-field>
                                </v-flex>
                                <v-flex xs12 sm12 md12 px-2>
                                    <v-textarea v-model="formClient.description"
                                        :counter="$v.formClient.description.$params.maxLength.max"
                                        :error-messages="descriptionErrors"
                                        @blur="$v.formClient.description.$touch()"
                                        rows="3"
                                        solo
                                        :disabled="clientShow"
                                        label="Descrição"
                                    ></v-textarea>
                                </v-flex>
                            </v-layout>
                        </v-container>
                    </v-tab-item>



                    <!--Tab Contact-->
                    <v-tab :key="'tab_contact'" ripple >Contacto</v-tab>
                    <v-tab-item :key="'tab_contact'" disabled>
                        <!--<v-card flat>-->
                        <v-container>
                            <v-text-field
                                v-model="newContactName"
                                append-outer-icon="done"
                                @click:append-outer="visuallyAddContact"
                                @keyup.enter="visuallyAddContact"
                                label="Novo Contacto"
                                v-if="!clientShow"></v-text-field>

                            <!--Expandable components (Contact list)-->
                            <v-expansion-panel popout :value="formClient.contacts_json.length === 1 ? 0 :1">
                                <p v-if="active_tab===1 && formClient.contacts_json.length <= 0">nenhum contacto adicionado ainda</p>
                                <v-expansion-panel-content
                                        v-for="(contact, index) in formClient.contacts_json"
                                        :key="index"
                                        :class="index%2 === 1? 'grey lighten-2' : 'grey lighten-3'"
                                >
                                    <div slot="header"><b>{{contact.name}}</b> <span v-if="contact.role"> - {{contact.role}}</span></div>


                                    <div style="padding: 10px; background: white" >
                                        <v-layout wrap>
                                            <v-flex xs12 sm6 px-2>
                                                <v-text-field
                                                    v-model="contact.role"
                                                    label="Descrição"
                                                    :readonly="clientShow"></v-text-field>
                                            </v-flex>
                                            <v-flex xs12 sm6 px-2>
                                                <v-text-field
                                                    v-model="contact.email"
                                                    label="Email"
                                                    :readonly="clientShow"></v-text-field>
                                            </v-flex>
                                            <v-flex xs12 sm6 px-2>
                                                <v-text-field
                                                    v-model="contact.phone"
                                                    label="Telefone"
                                                    prefix="(+238)"
                                                    mask="### ## ##"
                                                    :readonly="clientShow"></v-text-field>
                                            </v-flex>
                                            <v-flex xs12 sm6 px-2>
                                                <v-text-field
                                                    v-model="contact.mobile_phone"
                                                    prefix="(+238)"
                                                    label="Telemovel"
                                                    mask="### ## ##"
                                                    :readonly="clientShow"></v-text-field>
                                            </v-flex>

                                            <v-flex xs12 v-if="!clientShow && index > 0">
                                                <v-btn
                                                    small flat icon color="grey" @click="visuallyRemoveContact(index)">
                                                <v-icon>delete</v-icon>
                                                </v-btn>
                                            </v-flex>
                                        </v-layout>
                                    </div>
                                </v-expansion-panel-content>
                            </v-expansion-panel>
                        </v-container>
                    </v-tab-item>

                </v-tabs>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <div v-if="!loading_modal">
                        <v-btn depressed @click="close">Cancelar</v-btn>
                        <v-btn v-if="!clientShow && active_tab === 0" :disabled="$v.$invalid" color="primary" @click="active_tab = 1">Seguinte</v-btn>
                        <v-btn v-if="!clientShow && active_tab !== 0" :disabled="$v.$invalid" color="primary" @click="save">Guardar</v-btn>
                    </div>
                    <v-progress-circular v-else indeterminate color="primary" m-2 ></v-progress-circular>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <!--Receipt paper-->
        <receipt-paper></receipt-paper>

    </div>
</template>

<script>
    import Vue from "vue";
    import _ from 'lodash';
    import {eventBus} from "../../main";
    import {mapGetters} from 'vuex';
    import {Model, Types, Global} from "../../config";
    import {maxLength, minLength, minValue, required, requiredIf, maxValue} from 'vuelidate/lib/validators'
    import ReceiptPaper from '../receipt/ReceiptPaper';
    export default {
        name: "FormModal",

        beforeDestroy(){
            this.close();
        },

        data () {
            return {
                Global,
                Types,
                newContactName: '',
                active_tab: 0,
                loading_modal: false,
                companies: [], //list of companeis used in auto complete field (this is querried at the moment)

                //company form modal needed attributes
                company_types: [],
                company_categories: [],
                // cities: [],

                //AutoComplete
                isLoading: false,
            }
        },



        props: {
            active_states: Array,
            cities: Array,
            companyTypes: Array,
            categories: Array,
            subcategories: Array,
            simplifiedModal: {
                type: Boolean,
                default: false
            },
        },

        validations: {
            formClient: {
                name: {
                    required,
                    minLength: minLength(2),
                    maxLength: maxLength(100),
                },
                nif: {
                    required,
                    minValue: minValue(0),
                },
                types_company_type_id: {
                    required,
                },
                cities_id: {
                    required,
                },
                address: {
                    maxLength: maxLength(250),
                },
                postal_code: {
                    maxLength: maxLength(100),
                },
                active_state: {
                    required,
                },
                agreed_discount: {
                    maxValue: maxValue(100),
                    minValue: minValue(0),
                },
                website: {
                    maxLength: maxLength(100),
                },
                description: {
                    maxLength: maxLength(250),
                }
            }

        },

        components: {
            ReceiptPaper,
        },

        watch: {
            showClientModal(){
                if(this.showClientModal){
                    this.onClientModalOpened();
                }
            },

        },

        computed: {
            ...mapGetters([
                'loggedUser',
                'isLoggedUserSuperAdmin',
                'getToken'
            ]),
            showClientModal: {
                get(){
                    return this.$store.getters.getShowClientModal;
                },
                set(value){
                    this.$store.dispatch('setShowClientModal', value);
                }
            },
            selectedClient: {
                get(){
                    return this.$store.getters.getSelectedClient;
                },
                set(value){
                    this.$store.dispatch('setSelectedClient', value);
                }
            },
            formClient: {
                get(){
                    return this.$store.getters.getFormClient;
                },
                set(value){
                    this.$store.dispatch('setFormClient', value);
                }
            },
            selectedCompany: {
                get(){
                    return this.$store.getters.getSelectedCompany;
                },
                set(value){
                    this.$store.dispatch('setSelectedCompany', value);
                }
            },
            clientShow: {
                get(){
                    return this.$store.getters.getClientShow;
                },
                set(value){
                    this.$store.dispatch('setClientShow', value);
                }
            },
            showReceiptPaperModal: {
                get() {
                    return this.$store.getters.getShowReceiptPaperModal;
                },
                set(value) {
                    this.$store.dispatch('setShowReceiptPaperModal', value);
                }
            },
            selectedReceipt: {
                get() {
                    return this.$store.getters.getSelectedReceipt;
                },
                set(value) {
                    this.$store.dispatch('setSelectedReceipt', value);
                }
            },        
            showPaymentModal: {
                get(){ return this.$store.getters.getShowPaymentModal; },
                set(value){ this.$store.dispatch('setShowPaymentModal', value); }
            },

            formTitle () {
                this.consoleLog('ClientID: '+this.formClient.id);
                return this.clientShow ? 'Cliente' : (this.formClient.id ? 'Editar Cliente' : 'Novo Cliente');
            },
            nameErrors () {
                const errors = [];
                if (!this.$v.formClient.name.$dirty) return errors;
                // !this.$v.formClient.name.decimal && errors.push('Name must be a number')
                !this.$v.formClient.name.minLength && errors.push('Mínimo de 2 caracteres');
                !this.$v.formClient.name.maxLength && errors.push('Máximo de 30 caracteres');
                !this.$v.formClient.name.required && errors.push('Digite um nome');
                return errors
            },
            nifErrors () {
                const errors = [];
                if (!this.$v.formClient.nif.$dirty) return errors;
                !this.$v.formClient.nif.minValue && errors.push('Introduza valores não negativos');
                !this.$v.formClient.nif.required && errors.push('Introduza nif');
                return errors
            },
            companyTypeErrors(){
                const errors = [];
                if (!this.$v.formClient.types_company_type_id.$dirty) return errors;
                !this.$v.formClient.types_company_type_id.required && errors.push('Escolha um tipo de empresa');
                return errors
            },
            cityErrors () {
                const errors = [];
                if (!this.$v.formClient.cities_id.$dirty) return errors;
                !this.$v.formClient.cities_id.required && errors.push('Escolha uma cidade');
                return errors
            },
            addressErrors () {
                const errors = [];
                if (!this.$v.formClient.address.$dirty) return errors;
                // !this.$v.formClient.name.decimal && errors.push('Name must be a number')
                !this.$v.formClient.address.maxLength && errors.push('Maximo de 120 caracteres');
                return errors
            },
            postalCodeErrors () {
                const errors = [];
                if (!this.$v.formClient.postal_code.$dirty) return errors;
                // !this.$v.formClient.name.decimal && errors.push('Name must be a number')
                !this.$v.formClient.postal_code.maxLength && errors.push('Maximo de 30 caracteres');
                return errors
            },
            activeStateErrors () {
                const errors = [];
                if (!this.$v.formClient.active_state.$dirty) return errors;
                !this.$v.formClient.active_state.required && errors.push('Escolha um estado');
                return errors
            },
            agreedDiscountErrors (){
                const errors = [];
                if (!this.$v.formClient.agreed_discount.$dirty) return errors;
                !this.$v.formClient.agreed_discount.maxValue && errors.push('Máximo 100');
                !this.$v.formClient.agreed_discount.minValue && errors.push('Mínimo 0');
                return errors
            },
            websiteErrors () {
                const errors = [];
                if (!this.$v.formClient.website.$dirty) return errors;
                !this.$v.formClient.website.maxLength && errors.push('Maximo de 100 caracteres');
                return errors
            },
            descriptionErrors () {
                const errors = [];
                if (!this.$v.formClient.description.$dirty) return errors;
                // !this.$v.formClient.name.decimal && errors.push('Name must be a number')
                !this.$v.formClient.description.maxLength && errors.push('Maximo de 250 caracteres');
                return errors
            },
        },

        methods: {

            getContactsJson(item){
                let array = [];
                if(!item.contacts_json) return array;

                let newJsonArray = JSON.stringify(item.contacts_json);

                return JSON.parse(newJsonArray);
            },

            addClient(){
                try{
                    this.loading_modal = true;
                    Vue.axios.post('client', {
                        name: this.formClient.name,
                        nif: this.formClient.nif,
                        types_company_type_id: this.formClient.types_company_type_id,
                        cities_id: this.formClient.cities_id,
                        address: this.formClient.address,
                        agreed_discount: this.formClient.agreed_discount,
                        postal_code: this.formClient.postal_code,
                        active_state: this.formClient.active_state,
                        website: this.formClient.website,
                        contacts_json: this.formClient.contacts_json,
                        description: this.formClient.description,

                        category_id: this.formClient.category ? this.formClient.category.id : '',
                        category_name: this.formClient.category && this.formClient.category.id ? this.formClient.category.name : this.formClient.category,
                        model: Model.CLIENT,

                        subcategory_id: this.formClient.subcategory && this.formClient.subcategory.id ? this.formClient.subcategory.id : '',
                        subcategory_name: this.formClient.subcategory ? this.formClient.subcategory.name ? this.formClient.subcategory.name : this.formClient.subcategory : '',
                        subcategory_model: Model.CLIENT,
                    })
                    .then(response => {
                        this.consoleLog(response);
                        if(!response.data.success){
                            this.loading_modal = false;
                            this.handleErrorCodeMessage(response.data);
                            return;
                        }
                        this.$emit('onFormClientDone');
                        // this.active_tab = 0;
                        this.close();
                        this.showSnackBar('Cliente adicionado com sucesso', 'success');

                    }).catch(error => {
                        this.consoleLog(error);
                        this.showSnackBar('Ocorreu um erro ao adicionar cliente', 'error');
                    }).finally( ()=> {
                        this.loading_modal = false;
                    });
                }catch (e) {
                    this.showSnackBar('Ocorreu um erro ao adicionar cliente!', 'error');
                    this.loading_modal = false;
                }
            },

            updateClient(){
                try{
                    if(this.formClient === null) {
                        this.showSnackBar('Ocorreu um erro ao atualizar cliente', 'error');
                        return;
                    }

                    this.loading_modal = true;
                    Vue.axios.put('client/'+this.selectedClient.id, {
                        name: this.formClient.name,
                        nif: this.formClient.nif,
                        types_company_type_id: this.formClient.types_company_type_id,
                        cities_id: this.formClient.cities_id,
                        address: this.formClient.address,
                        agreed_discount: this.formClient.agreed_discount,
                        postal_code: this.formClient.postal_code,
                        active_state: this.formClient.active_state,
                        website: this.formClient.website,
                        contacts_json: this.formClient.contacts_json,
                        description: this.formClient.description,

                        category_id: this.formClient.category && this.formClient.category.id ? this.formClient.category.id : '',
                        category_name: this.formClient.category ? this.formClient.category.name ? this.formClient.category.name : this.formClient.category : '',
                        model: Model.CLIENT,

                        subcategory_id: this.formClient.subcategory && this.formClient.subcategory.id ? this.formClient.subcategory.id : '',
                        subcategory_name: this.formClient.subcategory ? this.formClient.subcategory.name ? this.formClient.subcategory.name : this.formClient.subcategory : '',
                        subcategory_model: Model.CLIENT,

                    }).then(response => {
                        this.consoleLog(response);
                        if(!response.data.success){
                            this.loading_modal = false;
                            this.handleErrorCodeMessage(response.data);
                            return;
                        }
                        this.$emit('onFormClientDone');
                        this.setUpCategoryAndSubcategory(this);
                        // this.active_tab = 0;
                        // this.$v.$reset();
                        this.close();
                        this.showSnackBar('Cliente atualizado com sucesso', 'success');

                    }).catch(error => {
                        this.consoleLog(error);
                        this.showSnackBar('Ocorreu um erro ao atualizar cliente', 'error');
                    }).finally( ()=> {
                        this.loading_modal = false;
                    });
                }catch (e) {
                    this.showSnackBar('Ocorreu um erro ao atualizar cliente!', 'error');
                    this.loading_modal = false;
                }
            },

            resetForm(){
                this.formClient.name = '';
                this.formClient.nif = '';
                this.formClient.types_company_type_id = '';
                this.formClient.cities_id = '';
                this.formClient.address = '';
                this.formClient.active_state = '';
                this.formClient.postal_code = '';
                this.formClient.website = '';
                this.formClient.contacts_json = [{ name:'Empresa',  phone: '', mobile_phone: '', email: '', role: ''}];
            },

            close () {
                this.showClientModal = false;
                this.newContactName = '';
                this.$v.$reset();
                this.resetForm();
                this.active_tab = 0;

                setTimeout(() => {
                    this.loading = false;
                    this.clientShow = false;
                }, 300);
            },

            save () {
                let vm = this;
                setTimeout(()=>{
                    if (vm.selectedClient.id) {
                        vm.updateClient();
                    } else {
                        vm.addClient();
                    }
                }, 100);
            },


            visuallyAddContact(){
                if(this.newContactName === '') return;
                let contact = {

                    name: this.role ? this.newContactName+' - '+this.role : this.newContactName,
                    role: this.role ? this.role : '',
                    email: this.email ? this.email : '',
                    mobile_phone: this.mobile_phone ? this.mobile_phone : '',
                    phone: this.phone ? this.phone : '',
                };
                if(!this.formClient.contacts_json){
                    this.formClient.contacts_json = [];
                }
                this.formClient.contacts_json.splice(1, 0, contact);
                this.newContactName = '';
            },

            visuallyRemoveContact(index){
                this.formClient.contacts_json.splice(index, 1);
            },

            getNewEmptyContact(){
                return { phone: '', mobile_phone: '', email: '', fax: ''}
            },

            setUpCategoryAndSubcategory(vm){
                if(!vm.categories) return;
                for(let i=0; i<vm.categories.length; i++){
                    // vm.consoleLog("category: "+vm.categories[i].id +'  |  '+vm.selectedClient.category_id);
                    if(vm.categories[i].id === vm.selectedClient.category_id){
                        vm.formClient.category = vm.categories[i];
                    }
                }
                if(!vm.subcategories) return;
                for(let i=0; i<vm.subcategories.length; i++){
                    // vm.consoleLog("subcategories: "+vm.subcategories[i].id +'  |  '+vm.selectedClient.subcategory_id);
                    if(vm.subcategories[i].id === vm.formClient.subcategory){
                        vm.formClient.subcategory = vm.subcategories[i];
                    }
                }
            },

            onClientModalOpened(){
                this.setUpCategoryAndSubcategory(this);
                if(this.selectedClient && !this.selectedClient.id){
                    this.formClient.active_state = 1;
                }
                if(!this.selectedClient.id){
                    this.formClient.contacts_json = [{ name:'Empresa',  phone: '', mobile_phone: '', email: '', role: ''}];
                }
            },

        },

    }
</script>

<style scoped>

</style>